import React,{useState,useEffect} from 'react'
import {reactLocalStorage} from 'reactjs-localstorage';
import {useHistory,useParams } from "react-router-dom";

const PartnerMapPage = () => {
    let history = useHistory();
    const { id_partner, secret_map } = useParams();

    //Map visibility
    const [isMapVisible, setIsMapVisible] = useState(false);
    
    useEffect(()=>{
        console.log("ID Partner:", id_partner);
        console.log("Secret Map:", secret_map);

        //Verifica della presenza del partner
    },[id_partner, secret_map]);

    return(
        <div>
            {
                isMapVisible && <p>Ecco la mappa</p>
            }
            {
                !isMapVisible && <p>Non hai accesso a questa mappa</p>
            }
        </div>
    )
}
export default PartnerMapPage

